var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetReject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668ZM6.92263 5.74424C6.59719 5.4188 6.06956 5.4188 5.74412 5.74424C5.41868 6.06968 5.41868 6.59732 5.74412 6.92275L6.82153 8.00016L5.74412 9.07757C5.41868 9.40301 5.41868 9.93065 5.74412 10.2561C6.06956 10.5815 6.59719 10.5815 6.92263 10.2561L8.00004 9.17867L9.07745 10.2561C9.40289 10.5815 9.93053 10.5815 10.256 10.2561C10.5814 9.93065 10.5814 9.40301 10.256 9.07757L9.17855 8.00016L10.256 6.92275C10.5814 6.59732 10.5814 6.06968 10.256 5.74424C9.93053 5.4188 9.40289 5.4188 9.07745 5.74424L8.00004 6.82165L6.92263 5.74424Z",
    fill: "#F4526B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetReject);
export default __webpack_public_path__ + "static/media/vet-reject.925a9d4708f2b33115a4bfac7bb6f856.svg";
export { ForwardRef as ReactComponent };